import { render, staticRenderFns } from "./red_talent5.vue?vue&type=template&id=4b50e49f&scoped=true"
import script from "./red_talent5.vue?vue&type=script&lang=js"
export * from "./red_talent5.vue?vue&type=script&lang=js"
import style0 from "./red_talent5.vue?vue&type=style&index=0&id=4b50e49f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50e49f",
  null
  
)

export default component.exports